import React from 'react';
import { Row, Col, Card } from 'antd';
import {
  TeamOutlined, ShoppingCartOutlined, SolutionOutlined, BarChartOutlined, CreditCardOutlined,
  DollarCircleOutlined, ReloadOutlined, BookOutlined, BankOutlined, FileTextOutlined, DashboardOutlined, PlusOutlined, UnorderedListOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

// Each route is a card, every "form" or "list" has its own card
const routeCards = [
  // Sales
  { label: 'add_sale', route: '/sales/form', icon: <PlusOutlined />, color: '#22d3ee' },
// { label: 'sale_list', route: '/sales/list', icon: <UnorderedListOutlined />, color: '#818cf8' },

  // Purchase
  { label: 'add_purchase', route: '/purchase/form', icon: <PlusOutlined />, color: '#f59e42' },
  // { label: 'purchase_list', route: '/purchase/list', icon: <UnorderedListOutlined />, color: '#fbbf24' },

  // Expenses
  { label: 'add_expense', route: '/expenses/form', icon: <PlusOutlined />, color: '#f43f5e' },
  // { label: 'expense_list', route: '/expenses/list', icon: <UnorderedListOutlined />, color: '#fca5a5' },

  // Returns
  { label: 'add_return', route: '/returns/form', icon: <PlusOutlined />, color: '#14b8a6' },
  // { label: 'return_list', route: '/returns/list', icon: <UnorderedListOutlined />, color: '#2dd4bf' },

  // Loan Repayment
  { label: 'add_loan_repayment', route: '/loan-repayments/form', icon: <PlusOutlined />, color: '#a21caf' },
  // { label: 'loan_repayment_list', route: '/loan-repayments/list', icon: <UnorderedListOutlined />, color: '#d946ef' },

  // Supplier Payments
  { label: 'add_supplier_payment', route: '/supplier-payments/form', icon: <PlusOutlined />, color: '#fde047' },
  // { label: 'supplier_payment_list', route: '/supplier-payments/list', icon: <UnorderedListOutlined />, color: '#facc15' },
  // Customers
  { label: 'customers', route: '/customers', icon: <TeamOutlined />, color: '#4f46e5' },
  // Products
  { label: 'products', route: '/products', icon: <BookOutlined />, color: '#10b981' },
  // Suppliers
  { label: 'suppliers', route: '/suppliers', icon: <BankOutlined />, color: '#eab308' },
  // Reports
  // { label: 'dashboard', route: '/report/dashboard', icon: <DashboardOutlined />, color: '#0284c7' },
  { label: 'product_stock_value_report', route: '/report/product-stock-value', icon: <BarChartOutlined />, color: '#0284c7' },
  { label: 'top_items', route: '/report/top-items', icon: <ShoppingCartOutlined />, color: '#818cf8' },
  { label: 'top_customers', route: '/report/top-customers', icon: <TeamOutlined />, color: '#14b8a6' },
  { label: 'top_suppliers', route: '/report/top-suppliers', icon: <BankOutlined />, color: '#f59e42' },
  { label: 'yearly_sales_chart', route: '/report/yearly-sales', icon: <BarChartOutlined />, color: '#f43f5e' },
  { label: 'daily_summary', route: '/report/daily-summary', icon: <FileTextOutlined />, color: '#a21caf' },
  { label: 'profit_report', route: '/report/profit-report', icon: <DollarCircleOutlined />, color: '#10b981' },
];

const DashboardPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '16px' }}>
      <Row gutter={[18, 18]} justify="start">
        {routeCards.map((item, idx) => (
          <Col xs={12} sm={8} md={6} lg={4} key={item.route + idx}>
            <Link to={item.route} style={{ textDecoration: 'none' }}>
              <Card
                hoverable
                variant="outlined"
                style={{
                  background: item.color,
                  color: "#fff",
                  borderRadius: 16,
                  boxShadow: "0 4px 16px 0 rgba(39,21,107,0.10)",
                  textAlign: "center",
                  minHeight: 120,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "transform 0.18s",
                }}
                styles={{
                  body: {
                    padding: "28px 12px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                }}
              >
                <div style={{ fontSize: 36 }}>{item.icon}</div>
                <div style={{
                  marginTop: 12,
                  fontWeight: 700,
                  fontSize: 17,
                  letterSpacing: 0.5,
                  color: "#fff"
                }}>
                  {t(item.label)}
                </div>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DashboardPage;
